import { render } from "./BotaoAltoContraste.vue?vue&type=template&id=f6171f9e&scoped=true"
import script from "./BotaoAltoContraste.vue?vue&type=script&lang=js"
export * from "./BotaoAltoContraste.vue?vue&type=script&lang=js"

import "./BotaoAltoContraste.vue?vue&type=style&index=0&id=f6171f9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6171f9e"]])

export default __exports__